<template>
	<div class="container-wrapper">
<go-back v-if="!$store.state.isMobile" v-model="form" url="/admin/organization-list" label="Back" :backToList="true"></go-back>
<b-container class="add-new-primary-organization-container" v-if="form != null && loaded">
<b-row v-if="!canEditOrganization()">
<b-col>
<h1>Organization Information</h1>

<b-row >
	<b-col class="mb-3">
		<div class="lcr-summary__label">Organization</div>
		<div class="lcr-summary__value" v-html="form.name.value"></div>
	</b-col>
</b-row>


	<b-row >
		<b-col class="mb-3">
			<div class="lcr-summary__label">Parent Organization</div>
			<div class="lcr-summary__value" v-html="getFlatTree(form.parentId.value)"></div>
		</b-col>
	</b-row>

	<b-row v-if="form.accessCode != null">
		<b-col class="mb-3">
			<div class="lcr-summary__label">Access Code</div>
				<ul>
					<li><strong v-html="form.accessCode"></strong></li>
					<li>Give the access code to people in your organization to have them register an account.</li>
			</ul>
		</b-col>
	</b-row>

		<b-row>
			<b-col>
				<b-form-group label="User@Domain"
					:state="form.name.status"
					:invalid-feedback="form.name.invalidMessage"
				>
				<b-input-group prepend="user">
					<b-form-input placeholder="@mycompany" :readonly="true" v-model="form.domain.value"></b-form-input>
				</b-input-group>
				</b-form-group>
			</b-col>
		</b-row>

		<b-row >
			<b-col class="mb-3">
				<div class="lcr-summary__label">Active Status</div>
				<div class="lcr-summary__value" v-html="getIsActiveText(form.isActive.value)"></div>
			</b-col>
		</b-row>

		<b-row >
			<b-col class="mb-3">
				<div class="lcr-summary__label">Approval Status</div>
				<div class="lcr-summary__value" v-html="getIsApprovedText(form.isApproved.value)"></div>
			</b-col>
		</b-row>
		</b-col>
	</b-row>

<b-form @submit="onSubmit" @reset="onReset" v-if="canEditOrganization()">
	<h1 class="page-title inner-page" v-if="form.parentId.value == null || form.parentId.value.id == -1">Edit Organization</h1>
	<h1 class="page-title inner-page" v-else>Edit Group</h1>

	<b-row v-if="hasParentId()">
		<b-col>
			<b-form-group label="Parent Organization / Group"
				:state="form.name.status"
				:invalid-feedback="form.name.invalidMessage"
			>
			<vue-select-grouped v-model="form.parentId.value" :canDelete="false" :options="organizations" label="name" :reduce="name => name.id" @input="setParentIdFromSelection">
				<template v-slot:option="optionGroup" :option="(typeof option === 'object')?option:{[name]: option, namePath:option.namePath, name:option.name, groupName:option.groupName}">
				</template>
				<template v-slot:option="option">
					<span :class="getLevelClassName(option.level)">{{ option.name }}</span>
				</template>
				<template v-slot:selected-option-container="option" :option="(typeof option === 'object')?option:{[name]: option, namePath:option.namePath, name:option.name}">
					<div class="vs__selected-options" v-html="getFlatTree(option.option)"></div>
				</template>
			</vue-select-grouped>
			</b-form-group>
		</b-col>
	</b-row>
	<b-row v-show="hasParentId()">
		<b-col>
			<b-form-group label="Name of Department, Division, Branch, or Group"
				:state="form.name.status"
				:invalid-feedback="form.name.invalidMessage"
			>
			<b-form-input placeholder="" v-model="form.name.value"
				:state="form.name.status"
				@input="form.name.resetStatus()"
			></b-form-input>
			</b-form-group>
		</b-col>
	</b-row>

	<b-row v-show="!hasParentId()">
		<b-col>
			<b-form-group label="Organization Name"
				:state="form.name.status"
				:invalid-feedback="form.name.invalidMessage"
			>
			<b-form-input placeholder="" v-model="form.name.value"
				:state="form.name.status"
				@input="form.name.resetStatus()"
			></b-form-input>
			</b-form-group>
		</b-col>
	</b-row>
	<b-row v-if="form.accessCode != null">
		<b-col class="mb-3">
			<div class="lcr-summary__label">Access Code</div>
				<ul>
					<li><strong v-html="form.accessCode"></strong></li>
					<li>Give the access code to people in your organization to have them register an account.</li>
			</ul>
		</b-col>
	</b-row>
	<b-row v-show="!hasParentId()">
		<b-col>
			<b-form-group label="User@Domain"
				:state="form.name.status"
				:invalid-feedback="form.name.invalidMessage"
			>
				<ul>
			<li>The user domain will be used as part of the login for users of your organization.</li>
			<li>The login name of each user will be in the form of <strong><em>user</em></strong><strong>@domain</strong>.</li>
			<li>All sub-organizations (groups, branches, etc.) will share the same user domain.</li>
			<li>The domain does not need to be the same as your email address domain.</li>
			</ul>
			<b-input-group prepend="admin">
				<b-form-input placeholder="@mycompany" v-model="form.domain.value" readonly></b-form-input>
			</b-input-group>
			</b-form-group>


			<b-form-group label="Type of Organization"
				:state="form.organizationTypeId.status"
				:invalid-feedback="form.organizationTypeId.invalidMessage"
				v-if="canSetApproval()"
			>
			<b-input-group>
				<b-form-select v-model="form.organizationTypeId.value"
					@input="form.organizationTypeId.resetStatus()"
					:state="form.organizationTypeId.status"
					:options="Organization.getOrganizationTypeId"
					value-field="value"
					text-field="text"
					inline
				></b-form-select>
			</b-input-group>
			</b-form-group>
		</b-col>
	</b-row>
	<b-row v-show="hasParentId()">
		<b-col>
			<b-form-group label="User@Domain"
				:state="form.name.status"
				:invalid-feedback="form.name.invalidMessage"
			>
			<b-input-group prepend="user">
				<b-form-input placeholder="@mycompany" :readonly="true" v-model="form.domain.value"></b-form-input>
			</b-input-group>
			</b-form-group>
		</b-col>
	</b-row>
	<b-row v-if="canSetApproval() && 1 == 2">
		<b-col>
	<b-form-group  label="Is Orgnization Approved?"
		:state="form.isApproved.status"
		:invalid-feedback="form.isApproved.invalidMessage"
		id="fg-is-approved"
		class="fg-is-approved"
	>
		<b-form-radio-group
			id="rg-is-approved"
			v-model="form.isApproved.value"
			:options="Organization.getIsApprovedOptions"
			@change="form.isApproved.resetStatus()"
			:state="form.isApproved.status"
		>
		</b-form-radio-group>
	</b-form-group>
		</b-col>
	</b-row>

	<b-row v-if="canSetActive() && hasParentId()">
		<b-col>
	<b-form-group  label="Group Status"
		:state="form.isActive.status"
		:invalid-feedback="form.isActive.invalidMessage"
		id="fg-is-active"
		class="fg-is-active"
	>
		<b-form-radio-group
			id="rg-is-active"
			v-model="form.isActive.value"
			:options="Organization.getIsActiveOptions"
			@change="form.isActive.resetStatus()"
			:state="form.isActive.status"
		>
		</b-form-radio-group>
	</b-form-group>
	</b-col>
	</b-row>


	<b-row v-if="canSetActive() && !hasParentId()">
		<b-col>
	<b-form-group  label="Is Organization Still Active?"
		:state="form.isActive.status"
		:invalid-feedback="form.isActive.invalidMessage"
		id="fg-is-active"
		class="fg-is-active"
	>
		<b-form-radio-group
			id="rg-is-active"
			v-model="form.isActive.value"
			:options="Organization.getIsActiveOptions"
			@change="form.isActive.resetStatus()"
			:state="form.isActive.status"
		>
		</b-form-radio-group>
	</b-form-group>
	</b-col>
	</b-row>

	<b-row v-if="canEditComments()">
		<b-col>
			<b-form-group label="Comments"
				:state="form.comments.status"
				:invalid-feedback="form.comments.invalidMessage"
			>
			<wysiwyg v-model="form.comments.value"></wysiwyg>
			</b-form-group>
		</b-col>
	</b-row>
<b-row>
	<b-col>
		<b-button class="create__organization" variant="primary" type="button" @click="onSubmit">Submit</b-button>
	</b-col>
</b-row>

<b-modal centered v-model="showRequiredFieldModal" type="info" @confirm="showRequiredFieldModal = false">
	<template v-slot:modal-title>{{$t('errors.errorsOccurred')}}</template>
	<ul>
		<li v-for="requiredField in modalRequiredFieldList" v-bind:key="'reqfield'+requiredField">{{$t(requiredField)}}</li>
	</ul>
	<template slot="footer">
		<b-button :disabled="isButtonDisabled" colour="light" :value="$t('labels.ok')" @click="modalRequiredFieldClose" />
	</template>
</b-modal>

<!-- leaving page -->
<b-modal centered id="unsaved-changes-error-modal" title="Unsaved Changes" size="lg" v-model="showUnsavedChangesModal" @ok="modalOnCancel()">
	<p class="is-size-6">{{ $t('messages.unsavedChanges') }}</p>
	<template v-slot:modal-footer="{ ok }">
		<!-- <b-button variant="primary"  type="button" @click="modalOnSave">{{$t('labels.save')}} <b-spinner small label="Saving..." class="ml-2" v-if="saving"></b-spinner></b-button> -->
		<b-button variant="danger" type="button" @click="modalOnLeave">{{$t('labels.leaveAnyway')}}</b-button>
		<b-button variant="secondary"  type="button" @click="modalOnCancel">{{$t('labels.stay')}}</b-button>
	</template>
</b-modal>

</b-form>
</b-container>
<Spinner v-else />
</div>
</template>


<script>
import Organization from '../../../models/Organization';
import ErrorHandler from '../../../utility/ErrorHandler';
import { VueSelectGrouped } from '../../../components/vue-select-grouped';
import GoBack from '../../../components/GoBack.vue';

import Spinner from "./../../../components/Spinner.vue";

import Format from '../../../utility/Format';
import Vue from 'vue'

export default {
  name: 'AddOrganization',
  docTitle: "Edit Organization - Lane Closures",

  components: {
		VueSelectGrouped,
		GoBack,
		Spinner,
  },

  data() {
	return {
		Organization,
		Format,
		form: null,
		loaded:false,
		parentOrganization:{id:-1,name:"Primary Organization", parentId:null},
		organizations: [],
		showUnsavedChangesModal:false,
		lineIndexError:null,
		isButtonDisabled: false,
		saveState:null,
		modalRequiredFieldList: [],
		showRequiredFieldModal: false,
		show: true,
		onSubmitPromiseDeferred: {
			resolve:null,
			reject:null
		},
	}
	},
	mounted() {
		this.LoadData(this.$route.params.id);
		this.$nextTick(() => {
		})
   },
	computed: {
	},

	watch: {
	},
  methods: {
	getIsApprovedText(val) {
		if (val) {
			return Organization.getIsApprovedText(val);
		}
		return null;
	},
	getIsActiveText(val) {
		if (val) {
			return Organization.getIsActiveText(val);
		}
		return null;
	},
	hasParentId() {
		if (this.form.parentId != null) {
			if (this.form.parentId.value != null) {
				if (this.form.parentId.value.id != null && this.form.parentId.value.id != -1) {
					return true;
				}
			}
		}
		return false;
	},
	canSetApproval() {
		if (this.$store.getters.userHasRole('internal_admin_requests') || this.$store.getters.userHasRole('system_admin')) {
			if (this.form) {
				if (this.form.parentId) {
					if (this.form.parentId.value) {
						if (this.form.parentId.value.id == -1 || this.form.parentId.value.id == null) {
							return true;
						}
					} else {
						return true;
					}
				}
			}
		}



		return false;
	},
	canSetActive() {
		if (this.$store.getters.userHasRole('internal_admin_requests') || this.$store.getters.userHasRole('system_admin')) {
			return true;
		}
		if (this.$store.getters.userHasRole('agency_admin') ) {
			return true;
		}
		return false;
	},
	canEditComments	() {
		if (this.$store.getters.userHasRole('internal_admin_requests') || this.$store.getters.userHasRole('system_admin')) {
			return true;
		}
		return false;
	},

	canEditOrganization() {
		if (this.$store.getters.userHasRole('internal_admin_requests') || this.$store.getters.userHasRole('system_admin')) {
			return true;
		} else {
			if (this.$store.getters.userHasRole('agency_admin')) {
				// verify that the user's organization ID is in the list of organizations...
				return this.$store.getters.canEditUserInOrganization(this.form.id, this.organizations);
			}
		}
		return false;
	},
	toggleIsApproved(item) {
		if (this.form.isApproved.value == 1) {
			this.form.isApproved.value = 0;
		} else {
			this.form.isApproved.value = 1;
		}
	},
	setParentIdFromSelection(val) {
		let x = 0;
		for (x = 0; x < this.organizations.length; x++) {
			if (typeof val == "object") {
				if (val.id == this.organizations[x].id) {
					this.parentOrganization = this.organizations[x];
					if (this.organizations[x].domain) this.form.domain.value = this.organizations[x].domain;
				}
			} else {
				if (val == this.organizations[x].id) {
					this.parentOrganization = this.organizations[x];
					if (this.organizations[x].domain) this.form.domain.value = this.organizations[x].domain;
				}
			}
		}
	},

	// required fields notifying modal
	modalRequiredFieldClose(){
		this.showRequiredFieldModal = false;
	},
	getFlatTree(option) {
		if (option) {
			if (option.namePath) {
				return Format.pipesToFlatTree(option.namePath);
			} else {
				return option.name;
			}
		}
	},
	showErrors(errors){
		this.submissionStatus = 'submission-error';
		this.modalRequiredFieldList = [];
		for(let field in errors) {
			this.modalRequiredFieldList.push(errors[field]);
		}
		this.showRequiredFieldModal = true;
	},

	getLevelClassName(level) {
		return "level-"+level;
	},
		onSubmit(evt) {
			evt.preventDefault()
			if (!this.validateFields()) {
				return false;
			}

			let that = this;
			return new Promise(function(resolve,reject){
				that.onSubmitPromiseDeferred.resolve = resolve;
				that.onSubmitPromiseDeferred.reject = reject;

				if (that.form.id) {
					that.SaveExisting(that.form);
				}
				else {
					that.SaveNew(that.form);
				}
			});

		},
		onReset(evt) {
			evt.preventDefault()
			this.show = false
			this.$nextTick(() => {
			this.show = true
			})
		},
		SaveNew(t) {
			// Saves a new organization
			if (t instanceof Organization) {
				let go = true;
				if (go) {
				Vue.prototype.$http({
					method: 'post',
					url: `${this.$store.state.apiUrl}/organization/?r=${Math.round(Math.random() * Math.pow(10, 6))}`,
					data: t.getRawValue()
				}).then(() => {
					// Handle Success
					this.saveState = 'success';
					this.submissionStatus = 'submission-success';
					this.SaveNewSuccess();
					this.onSubmitPromiseDeferred.resolve();
				}).catch(error => {
					this.saveState = 'fail';
					if (!ErrorHandler.HasLoginErrorCode(error)) {
						// this.form.SetErrors(error.response.data);
						this.showErrors(error.response.data.fields);
					} else {
						// ErrorHandler.RedirectToLogin();
					}
					this.onSubmitPromiseDeferred.reject();
				}).finally(() => {
					this.isButtonDisabled = false;
				});
				}
			}
		},
		SaveExisting(t) {
			if (t instanceof Organization) {
				Vue.prototype.$http({
					method: 'put',
					url: Format.getApiUrl("/organization/"+t.id),
					data: t.getRawValue()
				}).then(() => {
					this.saveState = 'success';
					this.submissionStatus = 'submission-success';
					this.SaveExistingSuccess();
					this.onSubmitPromiseDeferred.resolve();
				}).catch(error => {
					this.saveState = 'fail';
					if (error) {
						if (error.response) {
							if (!ErrorHandler.HasLoginErrorCode(error)) {
								// this.form.SetErrors(error.response.data);
								this.showErrors(error.response.data.fields);
							} else {
								ErrorHandler.RedirectToLogin();
							}
						}
					}
					this.onSubmitPromiseDeferred.reject();
				}).finally(() => {
				});
			}
		},

		SaveExistingSuccess() {
			// TODO: Show thank you message?
			this.form.saveChanges();
			this.$router.push("/admin/organization-list/");
		},

		SaveNewSuccess() {
			// TODO: Show thank you message?
			this.form.SetErrors({});
			// Start a new lane closure request?
			this.saveSuccess = 2;
			this.form.saveChanges();
		},

		validateFields() {

			let valid = this.form.validate();
			if (valid ) {
				return true;
			}
			return false;
		},

		GetOrganizations() {
			this.$store.dispatch('organizationList/loadEditable', {keywords:null})
						.then(() => {
								this.organizations = [];
								let records = this.$store.getters['organizationList/getRecords'];
								if ( records ) {
									if (this.form.parentId.value == null) {
										this.organizations.push({id:-1,name:"This is the Primary Organization", parentId:null});
									}
									records.forEach( item => {
										if (item.isActive == 0) item.name += " (inactive)";
										if (item.domain == this.form.domain.value) {
											// if (item.id != this.form.id) {
												this.organizations.push(item);
											// }
										}
										if (item.id == this.form.parentId.value) {
											this.form.parentId.value = item;
											if (item.domain != null) {
												this.form.domain.value = item.domain;
											}
										}
							this.loaded = true;
									})
								}
								if (this.form.parentId.value == null) {
									this.form.parentId.value = this.organizations[0];
									if (this.organizations[0].domain != null) {
										this.form.domain.value = this.organizations[0].domain;
									}
								}
							})
						.catch( error => console.log('error', error) ); // eslint-disable-line
		},

			LoadData(id = this.id) {
				this.loaded = false;
				// Remove any messages being displayed.
				this.submissionStatus = null;
				// this.form = new Organization();
				// this.form.parentId = null;
				if (id && Format.TryParseInt(id) > 0) {
					this.GetData(id);
				}
			},


			GetData(id) {

				if (Format.TryParseInt(id)) {
					this.loaded = false;
					Vue.prototype.$http.get(this.$store.state.apiUrl + "/organization/" + id + "/edit?r=" + Math.round(Math.random() * Math.pow(10, 6)))
					.then(response => {
						this.form = new Organization(response.data);
						// this.$store.commit('formId', response.data.Id);
						this.loaded = true;
						this.$nextTick(() => {
							this.GetOrganizations();
							this.setParentIdFromSelection(this.form.parentId.value);
							// console.log(this.form.parentId.getRawValue());
							this.form.saveChanges();
						})


					}).catch(error => {
						if (!ErrorHandler.HasLoginErrorCode(error)) {
							if (error.response && error.response.data) {
								this.loaded = false;
								this.transactionStatus = 'load-error';
								this.errorDetails = error.response.data;
							}
						} else {
							ErrorHandler.RedirectToLogin();
						}
					});
				}

			},

			modalOnCancel() {
				this.showUnsavedChangesModal = false;
				if (this.$store.getters.logoutRequested) {
					this.$store.commit('logoutRequested', false);
				}
			},


	},
	beforeRouteEnter(to, from, next) {
		next(vm => {
			Vue.prototype.$bus.$emit("map:clear", 1);
			Vue.prototype.$bus.$emit("map:toggle", 0);
	});
	},
	beforeRouteLeave(to, from, next) {
		if (this.loaded && this.form.hasChanges() && this.canEditOrganization()) {
			if (this.overrideUnsavedChanges) {
				next(true);
			} else {
				this.showUnsavedChangesModal = true;
				this.modalOnSave = (function() {
					this.onSubmit().then(() => {
						next(true);
					}).catch(() => {
						next(false);
					});
				}).bind(this);

				this.modalOnLeave = (function() {
					this.showUnsavedChangesModal = false;
					next(true);
				}).bind(this);

				next(false);
			}
		}
		else {
			next(true);
		}
	},

}
</script>
<i18n>
{
	"en-CA": {

	}
}

</i18n>